import React, { useContext } from "react";
import { ToastContainer } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
// import { useTranslation } from "react-i18next";
import { ToastContext } from "../../../Context/ToastContext";

function NotificationToast({
  position = "bottom-end",
  toastPosition = "bottom-end",
  autoHide = true,
  delay = 5000,
}) {
  const { toastMessages, removeToast } = useContext(ToastContext);

  return (
    <ToastContainer
      position={toastPosition}
      containerPosition={position}
      className="p-3"
      style={{
        maxWidth: "320px",
        minWidth: "300px",
        position: "fixed",
        zIndex: 999999,
      }}
    >
      {toastMessages.length > 0 &&
        toastMessages.map((toast) => (
          <Toast
            key={toast.id}
            className="d-inline-block m-1"
            bg={toast.variant ? toast.variant.toLowerCase() : "success"}
            autohide={autoHide}
            delay={toast?.delay || delay}
            animation={true}
            onClose={() => removeToast(toast.id)}
            style={{ width: "320px" }}
          >
            <Toast.Header>
              <strong className="me-auto text-white">
                {toast?.title || "Notification"}
              </strong>
            </Toast.Header>
            <Toast.Body className="bg-white">
              <p className="">{toast?.message || "No message"}</p>
            </Toast.Body>
          </Toast>
        ))}
    </ToastContainer>
  );
}

export default NotificationToast;
